import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { formStructureApi } from "api/TenantSlug/FormStructure/api";
import { composeGetFormStructureQueryOptions } from "api/TenantSlug/FormStructure/queryOptions.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import FormStructureData = App.Data.FormStructureData;
import GetFormStructureResponse = App.Http.Responses.FormStructure.GetFormStructureResponse;
import StoreFormStructureRequest = App.Http.Requests.FormStructure.StoreFormStructureRequest;
import GetFormStructuresRequest = App.Http.Requests.FormStructure.GetFormStructuresRequest;
import GetFormStructuresResponse = App.Http.Responses.FormStructure.GetFormStructuresResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

// Query to get a list of form objects
export const useGetFormStructuresQuery = (request: GetFormStructuresRequest, options = {}) => {
    return useQueryApi<GetFormStructuresResponse>({
        queryKey: ["getFormStructures", request],
        queryFn: () => formStructureApi.index(request),
        ...options,
    });
};

// Query to get a specific form object
// TODO WAITING FOR BE REQUEST
export const useGetFormStructureQuery = (formStructureId: string, request?: unknown, options = {}) => {
    return useQueryApi<GetFormStructureResponse>({
        ...composeGetFormStructureQueryOptions(formStructureId, request),
        ...options,
    });
};

// Mutation to store a new form object
export const useStoreFormStructureMutation = (
    options: UseMutationOptions<GetFormStructureResponse, AxiosError<ApiErrorResponse>, StoreFormStructureRequest> = {}
) => {
    return useMutationApi<GetFormStructureResponse, StoreFormStructureRequest>({
        mutationKey: ["storeFormStructure"],
        mutationFn: (request) => formStructureApi.store(request),
        ...options,
    });
};

// Mutation to update an existing form object
export const useUpdateFormStructureMutation = (formStructureId: string, options = {}) => {
    return useMutationApi<GetFormStructureResponse, StoreFormStructureRequest>({
        mutationKey: ["updateFormStructure", formStructureId],
        mutationFn: (request: StoreFormStructureRequest) => formStructureApi.update(request, formStructureId),
        ...options,
    });
};

// Mutation to destroy a form object
export const useDestroyFormStructureMutation = (options = {}) => {
    return useMutationApi<void, FormStructureData>({
        mutationKey: ["destroyFormStructure"],
        mutationFn: (formStructure: FormStructureData) => formStructureApi.destroy(formStructure),
        ...options,
    });
};

export const useExportFormStructuresMutation = (
    options: UseMutationOptions<ExportResponse, AxiosError<ApiErrorResponse>, BaseExportRequest> = {}
) => {
    return useMutationApi<ExportResponse, BaseExportRequest>({
        mutationKey: ["exportFormStructures"],
        mutationFn: (request) => formStructureApi.export(request),
        ...options,
    });
};
